import highcharts from "highcharts";

function guidGenerator() {
  var s4 = function() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };
  return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
}

export default function(angularModule) {
  angularModule.directive('listingStatsRow', function(listingStatsService) {
    return {
      restrict: 'A',
      scope: {
        listingStatsRow: '=',
        listingStatsLabel: '@'
      },
      template: `
        <h4><strong>{{listingStatsLabel}}</strong><i ng-show="!listingStatsRow.totalListings"> (No Data)</i></h4>
        <div class="row listing-stats-row">
          <div ng-if="listingStatsRow.totalListings > 0" class="col-md-6" ng-repeat="table in tables">
              <h5>{{table.name}}</h5>
              <table class="table">
              <tr ng-repeat="col in table.columns" uib-tooltip="{{col.hint}}">
                  <td>{{col.label}}</td>
                  <td ng-show="listingStatsRow[col.id] !== undefined" class="text-right">
                      <span ng-if="col.dataType === dataType.SUM">{{ listingStatsRow[col.id] | number : 0 }} </span>
                      <span ng-if="col.dataType === dataType.AVERAGE">{{ listingStatsRow[col.id] | number : 2 }}</span>
                      <span ng-if="col.dataType === dataType.PERCENT">{{ listingStatsRow[col.id] * 100 | number : 0 }}%</span>
                      <span ng-if="col.dataType === dataType.CATEGORIES && getKeys(listingStatsRow[col.id]).length > 0 "> 
                        <i id="{{guid + '-' + col.id}}"></i>
                      </span>
                  </td>
                  <td ng-show="listingStatsRow[col.id] === undefined"></td>
              </tr>
              </table>
          </div>
        </div>
        `,
      link(scope, element, attributes) {

        scope.guid = guidGenerator();
        scope.getKeys = Object.keys;
        scope.tables = [{
          name: "Search Statistics",
          columns: listingStatsService.searchColumns()
        }, {
          name: "Update Statistics",
          columns: listingStatsService.updateColumns()
        }];
        scope.dataType = listingStatsService.dataType;

        scope.$evalAsync(() => {

          highcharts.chart(
            document.querySelector('#' + scope.guid + '-successfulSearchTerms'),
            {
            chart: {
              type: 'pie',
              width: 125,
              height: 125,
            },
            title: {
              text: ''
            },
            credits: false,
            exporting: false,
            plotOptions: {
              pie: {
                size: 100,
                dataLabels: false
              }
            },
            series: [{
              name: 'Search Terms',
              colorByPoint: true,
              data: Object.keys(scope.listingStatsRow.successfulSearchTerms).map((key) => {
                return {
                  name: key,
                  y: scope.listingStatsRow.successfulSearchTerms[key]
                }
              })
            }]
          });
        })


      }
    }
  })
}
